import styled from 'styled-components';

export const Styled = styled.svg`
  fill: currentColor;
`;
